import TypeStrictData, { fieldType } from '@/classes/common/TypeStrictData';

/**
 * 問題情報クラス
 */
export default class QuestionData extends TypeStrictData {

  /** 単元No */
  @fieldType()
  public sectionNo: number = 0;

  /** 問題No */
  @fieldType()
  public questionNo: number = 0;

  /** ユニットNo */
  @fieldType()
  public unitNo: number = 0;

  /** 問題 */
  @fieldType()
  public question: string = '';

  /** 解答 */
  @fieldType()
  public right: string = '';

  /** 標準回答時間 */
  @fieldType()
  public standardSec: number = 0;

  /** 穴埋めタイプ */
  @fieldType()
  public blankType: string = '';

  /** 判定問題No */
  @fieldType()
  public judgeQuestionNo: number = 0;

  /** 復習問題No */
  @fieldType()
  public repeatQuestionNo: number = 0;

  /** 問題（questionが空の時に利用） */
  public q: string = '';

  /** 解答（questionが空の時に利用） */
  public a: string = '';



}
